import makeStyles from '@mui/styles/makeStyles';
import clsx from 'clsx';
import React from 'react';

const getStyles = makeStyles(() => ({
  root: {
    boxSizing: 'border-box',
    marginRight: 'auto',
    marginLeft: 'auto',
    paddingRight: 15,
    paddingLeft: 15,
    maxWidth: 1170,
  },
  wide: {
    maxWidth: 1280,
  },
}));

interface BodyProps {
  className?: string;
  children?: React.ReactNode;
  // Use the wider 1280px cap. Default 1170px is intentional for content-heavy
  // text pages; data-dense surfaces like the dashboard opt in to wide.
  wide?: boolean;
  [key: string]: unknown;
}

function Body({ className, children, wide, ...other }: BodyProps) {
  const s = getStyles();
  return (
    <div data-testid="page-body" className={clsx(s.root, wide && s.wide, className)} {...other}>
      {children}
    </div>
  );
}

export default Body;
